import main from './elements.svg';
import active from './elements-filled.svg';
import disabled from './elements-gestalt.svg';

export default { main, active, disabled };
